import React, { useEffect, useState } from "react";
import SEO from "../component/SEO";
import { useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = useSelector((state) => state.user.token);
  const isAdmin = useSelector((state) => state.user.isAdmin);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token || !isAdmin) {
      navigate("/");
      return;
    }

    const fetchUsers = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_SERVER_DOMIN}/all-users`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        const data = await res.json();
        
        if (res.ok) {
          setUsers(data);
        } else {
          toast.error(data.message || "Failed to fetch users");
        }
      } catch (err) {
        toast.error("An error occurred while fetching users");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [token, isAdmin, navigate]);

  if (loading) {
    return <div className="text-center p-10 font-bold text-xl">Loading users...</div>;
  }

  return (
    <div className="p-4 md:p-8 bg-gray-100 min-h-screen">
      <SEO title="Admin Users - K Bakery" description="View all registered users." />
      
      <div className="max-w-6xl mx-auto bg-white rounded shadow-md overflow-hidden">
        <div className="p-4 bg-purple-600 text-white font-bold text-lg md:text-xl text-center">
          Registered Users ({users.length})
        </div>

        <div className="overflow-x-auto p-4">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-gray-200 border-b text-sm uppercase text-gray-700">
                <th className="p-3">#</th>
                <th className="p-3">Name</th>
                <th className="p-3">Email</th>
                <th className="p-3">Date Joined</th>
                <th className="p-3">Verified</th>
                <th className="p-3 bg-red-100 border-r-2 border-red-200 text-red-800" title="Missing phone numbers might be a sign of bugs">Phone Number</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => {
                const date = new Date(user.createdAt);
                
                return (
                  <tr key={user._id} className="border-b hover:bg-gray-50 text-gray-700 text-sm md:text-base">
                    <td className="p-3">{index + 1}</td>
                    <td className="p-3 font-semibold">{user.firstName} {user.lastName}</td>
                    <td className="p-3">{user.email}</td>
                    <td className="p-3">{date.toLocaleDateString()} {date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</td>
                    <td className="p-3">
                      {user.emailVerified ? (
                        <span className="text-green-600 font-semibold bg-green-100 px-2 py-1 rounded">Yes</span>
                      ) : (
                        <span className="text-red-500 font-semibold bg-red-100 px-2 py-1 rounded">No</span>
                      )}
                    </td>
                    <td className="p-3 border-r-2 border-l-orange-50 bg-red-50 text-red-600 font-medium">
                      {user.phoneNumber || "-"}
                    </td>
                  </tr>
                );
              })}
              {users.length === 0 && (
                <tr>
                  <td colSpan="6" className="p-4 text-center text-gray-500">
                    No users found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminUsers;
